import { jdiColorFetch } from "./colorFetchV2";

// 前台类目接口
// export const getCategotyList = async () => {
//   // se_wishList_unFollow
//   const res = await jdiFetch("/cms_rootCateListAll", {
//     method: "get",
//   });
//   return res;
// };

// 前台类目接口
export const getCategotyList = async () => {
  const res = await jdiColorFetch("guide_catalog_getRootCates", {
    method: "get",
    next: { revalidate: 10 },
  });
  return res;
};

export const followApi = async ({ bizIds, bizType = "1" }: FollowReqParams) => {
  // se_wishList_follow bizIds， bizType 1商品、2店铺
  const res = await jdiColorFetch(`se_wishList_follow`, {
    method: "post",
    bodyQuery: {
      bizIds: [bizIds],
      bizType,
    },
  });
  return res;
};

export const getShopItem = async (params: any) => {
  const res = await jdiColorFetch(`guide_search_getItems`, {
    method: "post",
    bodyQuery: params,
    next: { revalidate: 10 }, // 搜索结果缓存10秒
  });
  return res;
};

export const getSearchResults = async (searchParams: any): Promise<any> => {
  const p = Object.assign({}, searchParams);
  p.keywords = p.k;
  delete p.k;
  p.pageSize = "20";

  p.couponBatchId = p.batchId;
  delete p.batchId;
  delete p.couponId;
  delete p.skuId;
  delete p.type;

  const { l1, l2, l3, b1, b2, b3, shopId, shopKeywords } = searchParams;
  const frontCategoryId = l3 || l2 || l1;
  if (frontCategoryId) {
    p.frontCategoryId = frontCategoryId;
    delete p.keywords;
  }

  const categoryId = b3 || b2 || b1;
  if (categoryId) {
    p.categoryId = categoryId;
    delete p.keywords;
  }
  if (shopId) {
    p.shopId = shopId;
    p.shopKeywords = shopKeywords;
    delete p.keywords;
  }
  const res = await getShopItem(p);
  return res;
};

export const getSearchFieldCollection = async (searchParams: any): Promise<any> => {
  const { l1, l2, l3, b1, b2, b3, promotionId, batchId, shopId, shopKeywords } = searchParams;
  const frontCategoryId = l3 || l2 || l1;
  const categoryId = b3 || b2 || b1;
  const p: any = { pageSize: "1" };
  // 前台类目Id
  if (frontCategoryId) {
    p.frontCategoryId = frontCategoryId;
  }
  // 后台类目Id
  if (categoryId) {
    p.categoryId = categoryId;
  }
  if (!frontCategoryId && !categoryId) {
    // 类目id和keywords不能同时存在，所以只有类目id不存在的时候才会传入keywords
    p.keywords = searchParams.k;
  }

  // 促销Id
  if (promotionId) {
    p.promotionId = promotionId;
  }
  if (batchId) {
    p.couponBatchId = batchId;
  }
  if (shopId) {
    p.shopId = shopId;
    p.shopKeywords = shopKeywords;
    delete p.keywords;
  }
  const searchResults = await getShopItem(p);
  return searchResults?.data?.fieldCollection || {};
};
